import { render, staticRenderFns } from "./data-empty.vue?vue&type=template&id=5a5171f8&"
var script = {}
import style0 from "./data-empty.vue?vue&type=style&index=0&id=5a5171f8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports